import { Image } from "@tiptap/extension-image";

export const EmojiImage = Image.extend({
  name: "emojiImage",
  priority: 1000,
  inline: true,
  group: "inline",
  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute("src"),
        renderHTML: (attributes: Record<string, unknown>) => ({
          src: attributes.src,
        }),
      },
      alt: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute("alt"),
        renderHTML: (attributes: Record<string, unknown>) => ({
          alt: attributes.alt,
        }),
      },
      class: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute("class"),
        renderHTML: (attributes: Record<string, unknown>) => {
          if (!attributes.class) return {};
          return {
            class: `${attributes.class} inline`,
          };
        },
      },
      "data-emoji": {
        default: "true",
        parseHTML: (element: HTMLElement) => element.getAttribute("data-emoji"),
        renderHTML: (attributes: Record<string, unknown>) => {
          if (attributes["data-emoji"]) {
            return {
              "data-emoji": attributes["data-emoji"],
            };
          }
          return {};
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "img[data-emoji]",
        getAttrs: (node: HTMLElement) => ({
          src: node.getAttribute("src"),
          alt: node.getAttribute("alt"),
          class: node.getAttribute("class"),
          "data-emoji": node.getAttribute("data-emoji"),
        }),
      },
    ];
  },

  renderHTML({ HTMLAttributes }: { HTMLAttributes: Record<string, unknown> }) {
    const { src, alt, class: className } = HTMLAttributes;
    return [
      "img",
      {
        src,
        alt,
        class: className || "w-[14px] h-[14px]",
        "data-emoji": "true",
      },
    ];
  },
});
